import ModalEdit from './ModalEdit'

export default ModalEdit



// WEBPACK FOOTER //
// ./src/views/Divisions/components/ModalEdit/index.js